import React, { useState } from 'react';
import PsychologistCard from './PsychologistCard';
import '../styles/FindPsychologist.css';


function FindPsychologist() {
  const psychologists = [
    {
      id: 0,
      name: "Фёдоров Игорь Валерьевич",
      description: "Кандидат психологических наук, психотерапевт. Доцент кафедры психологии личности ТГУ. Президент Ассоциации практикующих психологов",
      price: "",
      fullDescription: "Психотерапевт чем-то напоминает садовника, ухаживающего за заброшенным садом проле бури, потопа или заморозка. Постепенно оживляя засохшие цветы, деревья с поломанными ветками, восстанавливая зелень газонов через некоторое время превращает этот сад в цветущий оазис. \n\nТел.: +7 903 955 3396",
      imageUrl: "/images/IWF.png",
      contactLink: "https://t.me/Fedorov_App",
      topics: [
        "Поиск себя и интереса к жизни.",
        "Неуверенность в себе.",
        "Сложности выстраивания межличностных отношений.",
        "Переживания вины, стыда, одиночества, злости и других эмоциональных состояний.",
        "Тревожные состояния.",
        "Отношения в семье."
      ]
    },
    {
      id: 1,
      name: "Маркова Александра",
      description: "Дипломированный Клинический психолог (НИ ТГУ). Вице-президент Ассоциации практикующих психологов",
      price: "",
      fullDescription: "Для меня в работе важно установление доверия с клиентом, понимание личности с её индивидуальным опытом.",
      imageUrl: "/images/sascha.jpg",
      contactLink: "https://t.me/ourMpsy",
      topics: [
        "Поиск себя и интереса к жизни.",
        "Неуверенность в себе.",
        "Сложности выстраивания межличностных отношений.",
        "Переживания вины, стыда, одиночества, злости и других эмоциональных состояний.",
        "Тревожные состояния.",
        "Отношения в семье."
      ]
    },
    {
      id: 2,
      name: "Куринских Анастасия",
      description: "НИ ТГУ Факультет психологии, бакалавр по направлению подготовки общая психология и магистратуру по направлению Психология безопасности и здоровья",
      fullDescription: "Я развиваю себя как фототерапевт, поэтому в работе могу использовать работу с фотографиями. Для меня важно, чтобы ваши переживания были услышаны, не обязательно справляться со всем одному.",
      imageUrl: "/images/kurinskih.jpg",
      contactLink: "https://t.me/kinsvi_psy",
      topics: [
        "Отношения взрослых детей с родителями",
        "Отношения с окружающими и собой",
        "Сложности с выбором, принятием решений, постановка целей",
        "Секс, сексуальность",
        "Низкая самооценка",
        "Помощь в проживании кризисов, одиночества",
        "Потеря, смерть близкого человека"
      ]
    },
    {
      id: 3,
      name: "Малетина Александра",
      description: "Выпускница факультета психологии ТГУ",
      fullDescription: "Важно говорить о своих эмоциях, мыслях, желаниях. Чувствовать- это очень по-человечески.",
      imageUrl: "/images/maletina.jpg",
      contactLink: "https://t.me/tell_sash",
      topics: [
        "самооценка, неуверенность в себе;",
        "детско-родительские отношения;",
        "трудности в отношениях (партнерские, дружеские,профессиональные….);",
        "сложные эмоциональные состояния;",
        "депрессия;",
        "панические атаки;",
        "сложные жизненные ситуации, кризисы."
      ]
    },
    {
      id: 4,
      name: "Шевченко Ника",
      description: "Дипломированный Клинический психолог (НИ ТГУ)",
      fullDescription: "В своей работе я не навязываю как «правильно» или «неправильно». Моя задача заключается в том, чтобы помочь вам найти ваши собственные ответы на свои жизненные вопросы и научиться выстраивать жизнь с опорой на собственные желания, потребности, возможности и ограничения.",
      imageUrl: "/images/nika.jpg",
      contactLink: "https://t.me/nikaryadompsy",
      topics: [
        "Трудности в межличностных отношениях;",
        "Низкая самооценка, неуверенность в себе;",
        "Проблемы с личными границами;",
        "Желание разобраться в себе - понять себя, свои чувства и желания;",
        "Ощущение, что ходите по кругу и повторяете один и тот же жизненный сценарий;",
        "Сложные чувства и состояния: обида, вина, стыд, тревога, агрессия;",
        "Что-то беспокоит, но не знаете что."
      ]
    },
    {
      id: 5,
      name: "Корнева Марьяна",
      description: "Дипломированный Клинический психолог (НИ ТГУ)",
      fullDescription: "В работе с клиентом  я ставлю перед собой очень важную цель - помочь прийти к целостности, с помощью совместного выявления истинной проблемы, что стало препятствием в прохождении жизненного пути. Целостность - это то, в чем человек выстраивает здоровые межличностные отношения, то в чем этот мир воспринимается во всех его красках, то здоровое ощущение себя и отношение к себе к которому человек стремится. ",
      imageUrl: "/images/korneva.jpg",
      contactLink: "https://vk.com/kp.shiller",
      topics: [
        "Эмоциональное состояние: выгорание, напряжение, агрессия;",
        "Страхи, тревожные состояния;",
        "Чувства: обида, вина, стыд;",
        "Межличностные отношения и взаимоотношения с близкими;",
        "Отношение к себе: самооценка; непринятие себя; непонимание себя; неидентификация своих чувств, эмоций и потребностей;",
        "Поиск своей ресурсной составляющей и своих жизненных интересов."
      ]
    },
    {
      id: 6,
      name: "Рыбалова Татьяна",
      description: "НИИ ТГУ с отличием по специальности Социальный психолог",
      fullDescription: "Чувствуете одиночество, запутались и не видите выхода? Вы не один — и не обязаны справляться со всем в одиночку. Я помогу вам разобраться в своих чувствах, обрести внутреннее равновесие и научиться принимать себя.",
      imageUrl: "/images/rybalova.jpg",
      contactLink: "https://www.b17.ru/id907974/",
      topics: [
        "тревожность; чувство одиночества;",
        "проблемы в отношениях; недопонимания;",
        "низкая самооценка, неуверенность в себе, страх проявления;",
        "личностные кризисы, связанные с поиском своего «я»;",
        "проблемы с пониманием своих желаний (узнать и найти себя);",
        "отношения с окружающими; сложности с выбором, принятием решений;",
        "апатия, отсутствие смысла жизни;",
        "можно обратиться если просто хочется выговориться, поговорить по душам в безоценочной, конфиденциальной обстановке (получить поддержку, быть понятым и услышанным)."
      ]
    },
    {
      id: 8,
      name: "Семенова Анастасия",
      description: "Студент выпускного курса ТГУ по направлению Психология",
      fullDescription: "В работе с клиентом мы вместе идем по пути, который ведет к осознанности и улучшению качества жизни, по пути, который дает место и возможность быть услышанным, понятым и принятым.",
      price: " ",
      imageUrl: "/images/semenjva.jpg",
      contactLink: "https://t.me/Nastya_Semenova91",
      topics: [
        "Чувство одиночества;",
        "Поиск смысла жизни;",
        "Хроническая усталость;",
        "Трудности в отношениях;",
        "Эмоциональные сложности;",
        "Самопознание;",
        "Сложная адаптация к сложившейся ситуации;",
        "Нарушение сна."
      ]
    },
    {
      id: 9,
      name: "Пермякова Кристина",
      description: "Переквалификация в Международном институте процесс-ориентированной психологии и психотравматологии; студентка выпускного курса ТГУ ФП",
      fullDescription: "С бережным контактом и доверием, мы вместе будем исследовать ваш индивидуальный внутренний мир.\n\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Тел.: +7 923 405 13 43",
      imageUrl: "/images/kris.jpg",
      contactLink: "https://t.me/kristyapermyakova",
      topics: [
        "Эмоциональное саморегулирование",
        "Стресс и тревожность",
        "Самооценка и уверенность в себе",
        "Межличностные отношения",
        "Проблемы коммуникации",
        "Проблемы в семье и конфликты",
        "Проблемы с принятием себя",
        "Работа с негативными мыслями",
        "Построение целей и мотивация",
        "Развитие навыков самопомощи",
        "Проблемы адаптации и перемен",
        "Психосоматика и телесные проявления эмоций"
      ]
    },



    {
      id: 10,
      name: "Плеханова Екатерина",
      description: "Выпускница Сибирского Государственного медицинского университета. Выпускница Томского Государственного университета по направлению Психология",
      fullDescription: "«Понимаю. Принимаю. Поддерживаю.» - для меня важны доверие, безопасность и эффективность в работе с клиентом. Работаю следующих подходах: психодинамика, гипнотерапия, семейная терапия.",
      imageUrl: "/images/adamenko.jpg",
      contactLink: "https://t.me/vivereEST_cogitare",
      topics: [
        "Личностный рост и саморазвитие.",
        "Нахождение внутренней опоры, повышение самооценки и уверенности в себе.",
        "Преодоление тревоги, страхов.Работа с чувством вины, обиды, злости, пустоты и др.",
        "Управление стрессом, профилактика выгорания.",
        "Профориентация.",
        "Построение и улучшение взаимоотношений с партнером, друзьями, семьей.",
        "Преодоление конфликтов в отношениях.",
        "Преодоление чувства одиночества.",
        "Преодоление проблем в сексуальной жизни.Сниженное либидо.",
        "Трудности в адаптации (к новой роли, новой работе, переезду и др.). Поиск ресурсов.",
        "Психологическая поддержка в особых ситуациях (при беременности, при психосоматических расстройствах и др.). Осознание связи между эмоциями и телом."
      ]
    },
    {
      id: 11,
      name: "Курьянович Марина",
      description: "Дипломированный клинический психолог (СибГМУ) и сертифицированный гештальт-терапевт (МИГиП)",
      fullDescription: "Ценности, которые имеют большую значимость в работе – это ваше благополучие и моя способность быть рядом с вами и вашими чувствами, желание быть чуткой и проявлять заботу. Мне важно помогать вам развивать осознанность и те навыки, которые будут полезны для разрешения вашего запроса.",
      imageUrl: "/images/marinaK.jpg",
      contactLink: "https://t.me/marinastoboi",
      topics: [
        "непринятие себя и слабая самоценность: негативное отношение к себе;",
        "страх отвержения и созависимые отношения;",
        "сильное чувство тревоги, вины и стыда;",
        "перфекционизм и большое количество критики к себе или другим;",
        "внутриличностные конфликты: «не знаю, чего хочу»;",
        "трудности с доверием и построением близких отношений;",
        "ощущение пустоты жизни и депрессивные симптомы (в том числе уровень расстройства при наличии медикаментозной поддержки);",
        "психосоматические симптомы при сопровождении врача по профилю."
      ]
    },
   
    {
      id: 13,
      name: "Суханова Светлана",
      description: "Томский государственный университет. Магистр психологии",
      fullDescription: "",
      imageUrl: "/images/suhanova.jpg",
      contactLink: "https://t.me/svettasukhanova",
      topics: [
        "Отношение к себе: самооценка; непринятие себя; непонимание себя; неидентификация своих чувств, эмоций и потребностей",
        "Тревожные состояния",
        "Преодоление различных жизненных трудностей. Сложные переживания",
        "Сложности с адаптацией в новых условиях жизни (учеба, работа и т.д.)",
        "Чувства страха, вины, стыда",
        "Прокрастинация",
        "Ощущение, что жизнь проходит мимо",
        "Период принятия жизненно важных решений",
        "Трудности коммуникации",
        "Страх одиночества",
        "Поиск себя и интереса к жизни"
      ]
    },
    
   
    {
      id: 16,
      name: "Приходько Олеся ",
      description: "Психолог/психотерапевт психоаналитического направления",
      fullDescription: "Окончила Восточно-Европейский институт Психоанализа г. Санкт-Петербург по направлению психоанализ и Университет при Межпарламентской Ассамблее ЕврАзЭс г. Санкт-Петербург",
      imageUrl: "/images/olesa.jpg",
      contactLink: "https://vk.com/id9811961",
      topics: [
        "провожу индивидуальные консультации со взрослыми (старше 18 лет);",
        "не могу помочь людям с химическими зависимостями;",
        "эмоциональное напряжение, кризис;",
        "тревога, страхи, фобии;",
        "панические атаки;",
        "депрессия;",
        "агрессия;",
        "проблемы во взаимоотношениях с близкими;",
        "трудности в общении;",
        "психосоматические заболевания;",
        "проблемы детско-родительских отношений;",
        "трудности и кризисы супружеских отношений."
      ]
    },
    {
      id: 17,
      name: "Смирнов Евгений",
      description: "Магистрант ТГУ по специальности «Когнитивная психология и технологии»",
      fullDescription: "В своей работе я стараюсь стать для клиента опорой, на которую он может опереться в решении личностных проблем, а также создать безопасное пространство, в которым он может изучать свой внутренний мир, чувства и переживания.",
      imageUrl: "/images/smirnov.jpg",
      contactLink: "https://t.me/SmirovEugine",
      topics: [
        "Неуверенность в себе;",
        "Поиск внутренней опоры;",
        "Тревожные состояния;",
        "Поиск интересов в жизни;",
        "Работа с чувством вины, стыдом;",
        "Отношение к себе."
      ]
    },

    {
      id: 18,
      name: "Светлана Беккер",
      description: "Дипломированный психолог (ТГУ), психолог-психоаналитик (ВЕИП)",
      fullDescription: "Я психоаналитически-ориентированный психолог. Специализируюсь на индивидуальной психоаналитической психотерапии взрослых. С 2021 года веду частную практику и помогаю людям в гармонизации собственной жизни, решении проблем с пониманием себя и других.",
      imageUrl: "/images/sveta.jpg",
      contactLink: "https://t.me/lana_bekker",
      topics: [
        "желание понять себя, открыть неочевидные грани своей личности, найти собственные смыслы;",
        "переживание кризисов и тяжелых ситуаций;",
        "неудовлетворенность жизнью, чувство одиночества и пустоты;",
        "постоянное чувство вины;",
        "тревога, страхи, фобии, панические атаки;",
        "навязчивые мысли, действия и ритуалы;",
        "изменения настроения, апатия, депрессия, эмоциональная нестабильность, раздражительность;",
        "неустойчивая самооценка, сравнение себя с другими, непринятие себя;",
        "трудности в романтических отношениях, конфликты с партнером, эмоциональная зависимость;",
        "социальная тревожность, социофобия, перманентное чувство стыда при общении."
      ]
    },

    {
      id: 19,
      name: "Коровина София",
      description: "Дипломированный Клинический психолог (НИ ТГУ)",
      fullDescription: "Научу быть себе другом. Помогаю преодолеть последствия травмы и найти ресурсы для счастливой жизни, отношений и самореализации.",
      imageUrl: "/images/sofa.jpg",
      contactLink: "https://t.me/sofiya_way",
      topics: [
        "Истощение и усталость, нехватка сил и энергии, выгорание, потеря удовольствия и радости жизни",
        "Тревожность, повышенная раздражительность, негативные эмоции, навязчивые мысли",
        "Низкая самооценка и неуверенность в себе, страх проявляться и заявлять о себе",
        "Проблемы в отношениях, напряжение, конфликты, потеря романтики",
        "Сложности в общении с ребёнком, усталость и срывы, чувство вины, ощущение, что «потеряла себя» в материнстве",
        "Кризисные ситуации (смерть близкого, разрыв отношений, измена и проч.)",
        "ВДА (взрослые дети алкоголиков)"
      ]
    },

    {
      id: 20,
      name: "Бакулина Диана",
      description: "Студентка Московского института психологии по направлению «Психоанализ». Член Ассоциации практикующих психологов",
      fullDescription: "Работаю в психоаналитическом и динамическом подходе. Специализируюсь на психотерапии для взрослых в индивидуальном формате онлайн и офлайн.",
      imageUrl: "/images/di.jpg",
      contactLink: "https://t.me/mentisme",
      topics: [
        "тревога и ситуативные тревожные состояния",
        "неустойчивая самооценка",
        "желание исследовать себя, открыть новые стороны своей личности, понять свои паттерны поведения, их причины и следствия",
        "пониженное настроение, депрессия, чувство одиночества или пустоты",
        "травма, посттравматическое расстройство, комплексное посттравматическое расстройство",
        "трудности во взаимодействии с окружающими, с построением романтических или дружеских отношений",
        "проблемы во взаимоотношениях в семье, с родителями, с детьми",
        "перманентное чувство стыда или вины"
     
      ]
       },

      {
      id: 21,
      name: "Барановский Олег",
      description: "Студент бакалавриата Томского Государственного Университета по направлению Психология",
      fullDescription: "Стремлюсь к глубокому пониманию личности клиента, его психологических трудностей и работе с чувствами в здесь-и-сейчас. Считаю важным сделать так, чтобы клиент понимал, как именно наша работа поможет ему в решении его психологических проблем.",
      imageUrl: "/images/Oleg.jpg",
      contactLink: "https://t.me/ohleg",
      topics: [
        "проблемы в отношениях любого рода",
        "непонимание себя, своих желаний и интересов ",
        "утрата радости в жизни, преобладание негативных чувств, депрессивные состояния средней тяжести",
        "чувство нереализованности и неудовлетворённости жизнью",
        "острое или хроническое ощущение вины, стыда или тревоги",
        "чрезмерная эмоциональная импульсивность"
        
     
      ]
    },

    {
      id: 22,
      name: "Юркин Даниил",
      description: "Дипломированный Клинический психолог (НИ ТГУ)",
      fullDescription: "Я работаю в психодинамическом направлении. В работе для меня важно создание атмосферы, в которой человек ощущает контакт, ощущает, что перед ним живой человек, а не функция. Часто проблемы, формирующиеся в нашей жизни, формируются в контакте с другими людьми. Я убежден, что в таком случае и решить их можно только находясь в контакте. \n\nТел.: +7 923 410 9569",
      imageUrl: "/images/yurkin.jpg",
      contactLink: "https://t.me/yurkindness",
      topics: [
        "Требовательность к себе",
        "Низкая самооценка",
        "Сложности в отношениях",
        "Повторяющиеся сценарии",
        "Чувство вины и стыда",
        "Чувство пустоты"
      ]
    },








  ];

  const [currentSlide, setCurrentSlide] = useState(0);

 
  return (
  <main className="psychologists-page">

    {/* ШАПКА */}
    <section className="psychologists-intro">
      <div className="app-container">
        <div className="psychologists-intro__simple">
          <h1>Наши специалисты</h1>

          <p>
            Практикующие психологи Ассоциации с разным профессиональным
            опытом, направлениями работы и специализацией.
          </p>
        </div>
      </div>
    </section>

    {/* БЕСПЛАТНЫЕ КОНСУЛЬТАЦИИ */}
    <section className="psychologists-free">
      <div className="app-container">
        <div className="psychologists-free__box">
          <h2>3 консультации бесплатно</h2>

          <p>
            В рамках нашего сообщества вам предоставляется возможность пройти
            <strong> 3 консультации совершенно бесплатно</strong>.
            Оставьте заявку — мы подберём подходящего специалиста под ваш запрос
            и свяжемся с вами.
          </p>

          <p className="psychologists-free__note">
            В списке представлены специалисты, которые предоставляют
            3 бесплатные консультации. Если выбранного психолога нет в списке,
            к нему можно обратиться индивидуально на платной основе
            по указанным контактам.
          </p>

          <a
            href="https://www.buildin.ai/form/d3348ce1-f52c-4e18-9475-cb1333209568?code=GC2JSA"
            target="_blank"
            rel="noopener noreferrer"
            className="psychologists-free__button"
          >
            Оставить заявку
          </a>
        </div>
      </div>
    </section>

    {/* СПЕЦИАЛИСТЫ */}
    <section className="psychologists-list">
      <div className="app-container">
        <div className="psychologists-list__heading">
          <h2>Психологи АПП</h2>
        </div>

        <div className="psychologists-grid">
          {psychologists.map((psychologist) => (
            <PsychologistCard
              key={psychologist.id}
              name={psychologist.name}
              price={psychologist.price}
              description={psychologist.description}
              fullDescription={psychologist.fullDescription}
              imageUrl={psychologist.imageUrl}
              contactLink={psychologist.contactLink}
              topics={psychologist.topics}
            />
          ))}
        </div>
      </div>
    </section>

    {/* НА ГЛАВНУЮ */}
    <section className="psychologists-home">
      <div className="app-container">
        <div className="psychologists-home__inner">
          <a
            href="/"
            className="psychologists-home__button"
          >
            На главную
          </a>
        </div>
      </div>
    </section>

  </main>
  );
}

export default FindPsychologist;